import { Component, ChangeDetectorRef, NgZone, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { InactivityService } from '../../services/inactivity.service';

@Component({
  selector: 'app-session-timeout-modal',
  templateUrl: './session-timeout-modal.component.html',
  standalone: true,
  imports: [],
})
export class SessionTimeoutModalComponent implements OnInit, OnDestroy {
  secondsLeft = 30;

  private subscription = new Subscription();

  constructor(
    public modalRef: BsModalRef,
    private inactivityService: InactivityService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      // The service emits this outside NgZone (to avoid a full-app change
      // detection cycle every second), so re-enter the zone and mark for check.
      this.inactivityService.remainingTime$.subscribe((ms) => {
        this.ngZone.run(() => {
          this.secondsLeft = Math.max(0, Math.round(ms / 1000));
          this.cdr.markForCheck();
        });
      })
    );
  }

  stillHere(): void {
    this.inactivityService.extendSession();
    this.modalRef.hide();
  }

  logoutNow(): void {
    this.modalRef.hide();
    this.inactivityService.logoutNow();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
